define('views/profile/password',[
    'views/_base/baseview',
    'text!views/profile/password.html',
    'views/shared/button/button',
    'models/user/changepassword/changepassword'
], function (BaseView, Template, ButtonComponent, PasswordModel){
    'use strict';

    return BaseView.extend({
        id      : 'profile-password-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click .js-profile-password-save-btn'  : 'saveNewPassword',
            'click .js-profile-password-cancel-btn': 'cancelChange',
            'keyup .js-new-password' : 'passwordRulesChange',
            'focus .js-new-password' : 'showPasswordRules',
            'blur .js-new-password' : 'hidePasswordRules',
            'blur .js-new-password-retype' : 'removeErrorClass',
            'blur .js-current-password' : 'removeErrorClass',
            'click .js-input-password-toggle-show': 'togglePasswordVisibility',
            'click .js-input-password-toggle-hide': 'togglePasswordVisibility'
        },
        initialize: function(options){
            options = options || {};

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){
            var that = this;

            this.save_button = new ButtonComponent({
                // General
                elementName        : '.js-password-form-button',
                calling_view       : this,
                // Transactional
                is_transaction     : false,
                // Default
                btn_label          : 'Save',
                btn_callback       : this.saveNewPassword,
                btn_retry_callback : this.saveNewPassword,
                // Confirm
                btn_confirm        : false,
                // Cancel
                btn_cancel         : true,
                btn_cancel_label   : 'Cancel',
                btn_cancel_callback: this.cancelPassword,
                // Success
                btn_success        : true,
                btn_success_delay  : 700,
                btn_success_label  : 'OK',
                btn_success_message: 'Password successfully updated',
                btn_success_callback: this.passwordSaveSuccess,
                // Error
                btn_error          : true,
                btn_error_delay    : 700,
                btn_error_label    : 'Retry',
                btn_error_cancel_label: 'Cancel',
                btn_error_message  : 'Password could not be updated',
                btn_error_callback : this.canceledOnError
            });

        },

        saveNewPassword: function(processComplete, that){
            var that = (that) ? that : this;
            
            if(that.validatePasswordForm(processComplete)){

                var current_pw = that.$('.js-current-password'),
                    new_pw = that.$('.js-new-password'),
                    new_pw_retype = that.$('.js-new-password-retype'),
                    data = {
                        CurrentPassword: encrypt(current_pw.val()),
                        NewPassword: encrypt(new_pw.val()),
                        UG: pf.session.get('UserGUID')
                    };

                that.password_model = new PasswordModel();
                that.password_model.set(data);

                that.password_model.save(null, {
                    success: function(model, resp){

                        if(processComplete.name){
                            that.save_button[processComplete.name](true);
                        } else {
                            processComplete(true, that.save_button);
                        }
                        
                    },
                    error: function(model, resp){

                        switch(resp.status){
                            case 200:
                                if(processComplete.name){
                                    that.save_button[processComplete.name](true);
                                } else {
                                    processComplete(true, that.save_button);
                                }
                                break;
                            case 400:
                                if(processComplete.name){
                                    that.save_button[processComplete.name](false);
                                } else {
                                    processComplete(false, that.save_button);
                                }
                                break;
                            case 401:
                                if(processComplete.name){
                                    that.save_button[processComplete.name](false);
                                } else {
                                    processComplete(false, that.save_button);
                                }
                                break;
                            defaulft:
                                if(processComplete.name){
                                    that.save_button[processComplete.name](false);
                                } else {
                                    processComplete(false, that.save_button);
                                }
                                break;
                        };

                    }
                });

            }

        },

        validatePasswordForm: function(processComplete) {
            var pw_old_test = this.updatePasswordRules('.js-current-password','.js-current-password-feedback', true),
                pw_new_test = this.updatePasswordRules('.js-new-password','.js-new-password-feedback', true),
                pw_retype_test = this.updatePasswordRules('.js-new-password-retype','.js-new-password-retype-feedback', true);

            if(pw_old_test && pw_new_test && pw_retype_test){

                if($('.js-new-password').val() != $('.js-new-password-retype').val()){
                    this.save_button.updateErrorMessage(sysText['FV']['invalid']['passwordsDoNotMatch']);
                    this.save_button[processComplete.name](false);
                    return false;
                }

                return true;
            } else {
                // this.save_button.updateErrorMessage(sysText['FV']['invalid']['password']);
                this.save_button[processComplete.name](false);
                return false;
            }
        },

        togglePasswordVisibility: function(){
            var pw_input = this.$('.js-new-password'),
                toggle_button_show = this.$('.js-input-password-toggle-show'),
                toggle_button_hide = this.$('.js-input-password-toggle-hide');

            if(pw_input.attr('type') == 'password'){
                pw_input.attr('type','text');
                toggle_button_show.hide();
                toggle_button_hide.show();
            } else {
                pw_input.attr('type','password');
                toggle_button_hide.hide();
                toggle_button_show.show();
            }

        },

        removeErrorClass: function(e){
            var class_names = $(e.target).attr('class'),
                class_name = class_names.slice(class_names.indexOf(' ') + 1);
            
            if(!this.updatePasswordRules('.' + class_name)){
                $(e.target).parent().removeClass('error');
            }
        },

        showPasswordRules: function(){
            this.$('.js-password-rules').fadeIn();
        },

        hidePasswordRules: function(){
            this.$('.js-password-rules').fadeOut();
        },

        passwordRulesChange: function(){
            this.updatePasswordRules('.js-new-password','.js-new-password-feedback')
        },

        updatePasswordRules: function(input, feedback, display_error){
            var pw_input = this.$(input),
                pw_container = pw_input.parent(),
                pw_feedback = this.$(feedback),
                value = pw_input.val(),
                is_pw_toggle = pw_container.hasClass('password-toggle'),
                length_pattern = /^.{8,}$/,
                capital_pattern = /.*[A-Z]/,
                lowercase_pattern = /.*[a-z]/,
                number_pattern = /.*[0-9]/,
                pw_failed = false;

            if(length_pattern.test(value)){

                if(is_pw_toggle){
                    pw_container.find('.js-password-rules').find('.js-password-length').addClass('text-green');
                }
                
            } else {

                if(is_pw_toggle){
                    pw_container.find('.js-password-rules').find('.js-password-length').removeClass('text-green');
                }
                
                pw_failed = true;
            }

            if(capital_pattern.test(value)){

                if(is_pw_toggle){
                    pw_container.find('.js-password-rules').find('.js-password-uppercase').addClass('text-green');
                }
                
            } else {

                if(is_pw_toggle){
                    pw_container.find('.js-password-rules').find('.js-password-uppercase').removeClass('text-green');
                }
                
                pw_failed = true;
            }

            if(lowercase_pattern.test(value)){

                if(is_pw_toggle){
                    pw_container.find('.js-password-rules').find('.js-password-lowercase').addClass('text-green');
                }
                
            } else {

                if(is_pw_toggle){
                    pw_container.find('.js-password-rules').find('.js-password-lowercase').removeClass('text-green');
                }
                
                pw_failed = true;
            }

            if(number_pattern.test(value)){

                if(is_pw_toggle){
                    pw_container.find('.js-password-rules').find('.js-password-number').addClass('text-green');
                }
                
            } else {

                if(is_pw_toggle){
                    pw_container.find('.js-password-rules').find('.js-password-number').removeClass('text-green');
                }
                
                pw_failed = true;
            }

            if(pw_failed){

                if(pw_feedback.length > 0 && display_error){
                    pw_container.addClass('error');
                    pw_feedback.show();
                }

                return false;
            } else {

                pw_container.removeClass('error');
                pw_feedback.hide();

                return true;
            }
        },

        passwordSaveSuccess: function(resetButton, that){
            var that = (that) ? that : this;
            
            that.cancelPassword();

            if(resetButton.name){
                that.save_button[resetButton.name]();
            } else {
                resetButton(that.save_button);
            }
            
        },

        cancelPassword: function(that){
            var that = (that) ? that : this;

            that.$('.js-current-password').val('');
            that.$('.js-new-password').val('');
            that.$('.js-new-password-retype').val('');
        },

        canceledOnError: function(that){
            // pf.navigate('#password');
        },

        close: function(){}
    });
});

